import VisibleComponent from '../VisibleComponent'
import './index.less'
import Star from "../Star";
import Icon from "../Icon";
import Button from "../Button";
import Ad from "../Ad";
import Text from "../Text";

const template = `
    <div class="simple-banner-container">
        <div class="info">
                <div class="icon-box"></div>
                <div class="info-content">
                    <div class="info-other">
                        <div class="title-box"></div>
                        <div class="desc-box"></div>
                        <div class="rate-box"></div>
                    </div>
                    <div class="install-box"></div>
                </div>
            </div>
        <div class="mask"></div>
    </div>
`

/**
 * 简单banner类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class SimpleBanner extends VisibleComponent {
    constructor(options = {}) {
        super(options)
        this.template = template
        this.init(options)
    }

    init(options) {
        super.init(options)
        this.maskBox = this.element.querySelector('.mask')
        this.iconBox = this.element.querySelector('.icon-box')
        this.buttonBox = this.element.querySelector('.install-box')
        this.titleBox = this.element.querySelector('.title-box')
        this.descBox = this.element.querySelector('.desc-box')
        this.rateBox = this.element.querySelector('.rate-box')
        this.render(options)
    }

    render(options) {
        const {
            icon,
            ad = true,
            buttonText = 'Install',
            title,
            desc,
            rating,
            star,
            numberRating,
            theme,
            color,
            iconShape = '',
            iconSize = '3',
            buttonType = 'cta',
            onClick,
            onIconClick,
            onButtonClick,
        } = options
        onClick && this.onClick(onClick)
        console.log("button ,onButtonClick,",onButtonClick)
        // 设置背景色
        switch (theme) {
            case "white":
                this.maskBox.style.backgroundColor = "#fff";
                break;
            case "black":
                this.maskBox.style.backgroundColor = "#000";
                this.maskBox.style.opacity = "0.7";
                break;
            case "transparent":
                this.maskBox.style.backgroundColor = "transparent";
                break;
            default:
                this.maskBox.style.backgroundColor = "#fff";
        }
        if (icon) {
            const iconComp = new Icon({
                url: options.icon,
                onClick: onIconClick,
                size:iconSize,
                shape:iconShape
            })
            iconComp.appendTo(this.iconBox)
        }
        let btn;
        if(buttonType === 'cta'){   // cta按钮
            if(theme === "black" || theme === "transparent"){
                btn = new Button({
                    type: "cta",
                    text: buttonText,
                    onClick: onButtonClick,
                    theme:"black"
                })
            }else if(theme === "white" || !theme){
                btn = new Button({
                    type: "cta",
                    text: buttonText,
                    onClick: onButtonClick,
                    theme:"white"
                })
            }
        }else if(buttonType === 'default'){  // default:白底黑字按钮
            if(theme === "black" || theme === "transparent"){
                btn = new Button({
                    type: "default",
                    text: buttonText,
                    onClick: onButtonClick,
                    theme:"black"
                })
            }else if(theme === "white" || !theme){
                btn = new Button({
                    type: "default",
                    text: buttonText,
                    onClick: onButtonClick,
                    theme:"white"
                })
            }
        }
        btn.appendTo(this.buttonBox);
        if (title) {
            let titleComp;
            // 如果皮肤为黑色，且没有设置颜色，或皮肤为透明，都设置文字颜色为白色
            if(theme === "black" && !color || theme === "transparent"){
                titleComp = new Text({
                    text: title,
                    type: "title",
                    color:"#fff"
                })
            }else{
                // 如果不是黑色皮肤，title默认为黑色，如果设置了颜色，则进行颜色替换
                titleComp = new Text({
                    text: title,
                    type: "title",
                    color:color
                })
            }
            titleComp.appendTo(this.titleBox)
        }
        if (desc) {
            let descComp;
            // 如果皮肤为黑色，且没有设置颜色，或皮肤为透明，都设置文字颜色为白色
            if(theme === "black" && !color || theme === "transparent"){
                descComp = new Text({
                    text: desc,
                    type: "desc",
                    color:"#fff"
                })
            }else{
                // 如果不是黑色皮肤，desc默认为#666，如果设置了颜色，则进行颜色替换
                descComp = new Text({
                    text: desc,
                    type: "desc",
                    color:color
                })
            }
            descComp.appendTo(this.descBox);
        }
        if (star) {
            const starComp = new Star({
                star
            })
            starComp.appendTo(this.rateBox);
        }
        if(rating){
            let ratingComp;
            // 如果皮肤为黑色，且没有设置颜色，或皮肤为透明，都设置文字颜色为白色
            if(theme === "black" && !color || theme === "transparent"){
                ratingComp = new Text({
                    text: rating,
                    type: "rating",
                    color:"#fff"
                })
            }else{
                // 如果不是黑色皮肤，默认为#666，如果设置了颜色，则进行颜色替换
                ratingComp = new Text({
                    text: rating,
                    type: "rating",
                    color:color
                })
            }
            ratingComp.appendTo(this.rateBox);
        }
        if(numberRating){
            let numberRatingComp;
            // 如果皮肤为黑色，且没有设置颜色，或皮肤为透明，都设置文字颜色为白色
            if(theme === "black" && !color || theme === "transparent"){
                numberRatingComp = new Text({
                    text: numberRating,
                    type: "numberRating",
                    color:"#fff"
                })
            }else{
                // 如果不是黑色皮肤，默认为#666，如果设置了颜色，则进行颜色替换
                numberRatingComp = new Text({
                    text: numberRating,
                    type: "numberRating",
                    color:color
                })
            }
            numberRatingComp.appendTo(this.rateBox);
        }
        if(ad){
            const adComp = new Ad()
            adComp.appendTo(this.element);
        }
    }

    appendTo(target) {
        return new Promise(resolve => {
            if(target instanceof HTMLElement){
                target.appendChild(this.element)
            }else if(target instanceof VisibleComponent){
                target.element.appendChild(this.element)
            }
            resolve(this.show())
        })
    }

    hasShow() {
        return this.hasShown
    }
}

export default SimpleBanner